var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"display":"flex"}},[_c('VideoUpload',{staticStyle:{"text-align":"left"},attrs:{"video":_vm._value},on:{"upload-success":_vm.videoUploadSuccess,"del":_vm.videoDel}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }